module.exports = __webpack_public_path__ + "static/media/text-me.279fca58.svg";